(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    class ShopDropdown extends HTMLElement {
    #hoverTimer = null;
    #leaveTimer = null;

    static HOVER_DELAY = 300;
    static LEAVE_DELAY = 300;

    connectedCallback() {
      this.trigger = this.querySelector('.shop-dropdown__trigger');
      this.panel = this.querySelector('[data-submenu]');
      if (!this.trigger || !this.panel) return;

      this.trigger.addEventListener('pointerenter', this.#onEnter);
      this.trigger.addEventListener('pointerleave', this.#onLeave);
      this.panel.addEventListener('pointerenter', this.#onPanelEnter);
      this.panel.addEventListener('pointerleave', this.#onLeave);
      this.trigger.addEventListener('focusin', this.#onFocusIn);
      this.addEventListener('focusout', this.#onFocusOut);
    }

    disconnectedCallback() {
      this.#clearTimers();
      this.trigger?.removeEventListener('pointerenter', this.#onEnter);
      this.trigger?.removeEventListener('pointerleave', this.#onLeave);
      this.panel?.removeEventListener('pointerenter', this.#onPanelEnter);
      this.panel?.removeEventListener('pointerleave', this.#onLeave);
      this.trigger?.removeEventListener('focusin', this.#onFocusIn);
      this.removeEventListener('focusout', this.#onFocusOut);
    }

    #onEnter = () => {
      clearTimeout(this.#leaveTimer);
      this.#leaveTimer = null;
      this.#hoverTimer = setTimeout(() => {
        this.#activate();
      }, ShopDropdown.HOVER_DELAY);
    };

    #onPanelEnter = () => {
      clearTimeout(this.#leaveTimer);
      this.#leaveTimer = null;
    };

    #onLeave = () => {
      clearTimeout(this.#hoverTimer);
      this.#hoverTimer = null;
      this.#leaveTimer = setTimeout(() => {
        this.#deactivate();
      }, ShopDropdown.LEAVE_DELAY);
    };

    #onFocusIn = () => {
      this.#clearTimers();
      this.#activate();
    };

    #onFocusOut = (e) => {
      if (!this.contains(e.relatedTarget)) {
        this.#deactivate();
      }
    };

    get headerComponent() {
      return this.closest('header-component');
    }

    #activate() {
      this.setAttribute('aria-expanded', 'true');
      this.trigger.setAttribute('aria-expanded', 'true');

      const header = this.headerComponent;
      if (!header || !this.panel) return;

      const submenuHeight = this.panel.offsetHeight;
      const headerHeight = header.offsetHeight;

      header.style.setProperty('--submenu-height', `${submenuHeight}px`);
      header.style.setProperty('--full-open-header-height', `${submenuHeight + headerHeight}px`);
    }

    #deactivate() {
      this.setAttribute('aria-expanded', 'false');
      this.trigger.setAttribute('aria-expanded', 'false');

      const header = this.headerComponent;
      if (!header) return;

      header.style.setProperty('--submenu-height', '0px');
      header.style.setProperty('--full-open-header-height', '0px');
    }

    #clearTimers() {
      clearTimeout(this.#hoverTimer);
      clearTimeout(this.#leaveTimer);
      this.#hoverTimer = null;
      this.#leaveTimer = null;
    }
  }

  if (!customElements.get('shop-dropdown')) {
    customElements.define('shop-dropdown', ShopDropdown);
  }
  } catch(e) { console.error(e); }
})();

})();
